import PopoverWrapper from "../PopoverWrapper";
import { Button } from "../ui/button";
import { useAuth } from "@clerk/clerk-react";
import { Link, useNavigate } from "react-router";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../ui/accordion";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { GearIcon } from "@radix-ui/react-icons";
import { TierBadge } from "../TierBadge";
import { useTanFetch } from "@/hooks/useTanFetch";
import type { ApiResponse, User } from "@/types";

const SettingsMenu = ({
  handleSignOut,
}: {
  handleSignOut: () => Promise<void>;
}) => {
  return (
    <ul className="text-xs flex flex-col gap-y-2">
      <li className="">
        <Link className="pt-6 hover:text-flamingo" to="/settings">
          Site Settings
        </Link>
      </li>
      <li className="md:py-0">
        <Link className="hover:text-flamingo" to="/user-settings">
          User Settings
        </Link>
      </li>
      <li className="md:py-0">
        <Button
          size="xs"
          variant="link"
          className="text-xs cursor-pointer p-0 m-0 hover:!text-flamingo"
          onClick={handleSignOut}
        >
          Logout
        </Button>
      </li>
    </ul>
  );
};

export default function UserMenuTrigger() {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("mobile");

  const { data: userData } = useTanFetch<ApiResponse<User>>(["user"], true);
  const subscriptionTier =
    userData?.data?.subscriptionStatus === "ACTIVE" ? "ACTIVE" : "FREE";

  const handleSignOut = async () => {
    await signOut();
    navigate("/sign-in");
  };
  return isMobile ? (
    <div className="flex items-center gap-2">
      {/* <TierBadge tier={subscriptionTier} className="text-xs" /> */}
      <PopoverWrapper
        // asChild
        content={<SettingsMenu handleSignOut={handleSignOut} />}
        customClasses="w-fit min-w-[175px]"
        // side="top"
        // align="end"
        // alignOffset={0}
        trigger={
            <GearIcon className="w-5 h-5" />
        }
      />
    </div>
  ) : (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <span className="text-xs">&gt;</span>
        <TierBadge tier={subscriptionTier} className="text-xs" />
      </div>
      <Accordion type="single" collapsible>
        <AccordionItem value="filters" className="border-none">
          <AccordionTrigger className="py-0 text-xs hover:no-underline hover:text-flamingo">
            &gt; Settings
          </AccordionTrigger>
          <AccordionContent className="border-none">
            <SettingsMenu handleSignOut={handleSignOut} />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
